/**
 * Coupon entity class
 */

import moment from 'moment'

/**
 * CouponFactory
 * returns Coupon entity class
 *
 * @class CouponFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Coupon} class
 *
 * @ngdoc factory
 * @name mwApp.factory:CouponFactory
 */
/* @ngInject */
export default function CouponFactory (Entity, m2mMixin, onOffMixin) {
  /* === Coupon class === */

  /**
   * Coupon model
   *
   * @class Coupon
   * @classdesc Coupon model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @return {models.Coupon} Coupon entity
   */
  function Coupon () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Coupon.prototype = Object.create(Entity.prototype)
  Coupon.prototype.constructor = Coupon

  /* === Coupon instance methods & fields === */

  Object.assign(Coupon.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Coupon#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      currencyId: Number,
      networkId: Number,
      value: 1,
      maxRedeemAmount: Number,
      type: 'PERCENT',
      createdBy: String,
      startTime: String,
      endTime: String,
      $fromDate: Date,
      $toDate: Date,
      $toDateUnlimited: false,
      $usageUnlimited: false,
      $couponType: 'STANDARD',
      couponCode: String,
      couponOverridesDiscount: true,
      assignedSubscriber: Number,
      usageLimit: 1,
      usageCount: 0,
      $addAmountLimit: false
    },

    /**
     * url template
     *
     * @memberof models.Coupon#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/discounts/{{::id}}',

    /**
     * Prepare object
     *
     * @memberof models.Coupon#
     * @override
     */
    _prepare: function () {
      if (!this.endTime) {
        this.$toDateUnlimited = true
      }

      if (!this.usageLimit) {
        this.$usageUnlimited = true
      }

      this.$addAmountLimit = !!this.maxRedeemAmount

      /* Note: set default values. */
      this.$fromDate = this.startTime ? moment(this.startTime).toDate() : moment().toDate()
      this.$toDate = this.endTime ? moment(this.endTime).toDate() : this.$fromDate
    },

    /**
     * Get underlying object
     *
     * @memberof models.Coupon#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      this.startTime = moment.utc(moment(this.$fromDate).tz(moment.defaultZone.name)).format('YYYY-MM-DDTHH:mm:ss[Z]')
      this.endTime = moment.utc(moment(this.$toDate).tz(moment.defaultZone.name)).format('YYYY-MM-DDTHH:mm:ss[Z]')

      if (this.$toDateUnlimited) {
        this.endTime = null
      }
      if (!this.$addAmountLimit) {
        this.maxRedeemAmount = 0
        this.currencyId = null
      }
      if (this.$usageUnlimited) {
        this.usageLimit = 0
      }

      return Entity.prototype._object.apply(this, arguments)
    }

  }, onOffMixin)

  /* === Coupon static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Coupon, Entity)
  Coupon._name = 'Coupon'
  Coupon._publicName = 'Coupon'
  Coupon.init()

  // permissions
  Coupon.access = {
    view: '',
    create: '',
    edit: '',
    delete: ''
  }

  // extra
  Coupon.extra = {
    currencies: []
  }

  return Coupon
}
